import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Utils } from '../../../core/utils/tools/utils.tools';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { GeneralMeetingModel } from '../../../models/general-meeting.model';
import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'sl-general-meeting-export-dialog',
    templateUrl: './general-meeting-export-dialog.component.html',
    styleUrls: ['./general-meeting-export-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralMeetingExportDialogComponent implements OnInit {
    isDone = false;
    hasError = false;
    downloadFileName: string;
    downloadFile: Blob;
    currentMeeting: GeneralMeetingModel;
    currentLocaleCode = 'de';

    private readonly dialogRef = inject(MatDialogRef);
    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);
    private readonly translationService = inject(TranslationService);

    ngOnInit(): void {
        this.currentLocaleCode = this.translationService.getCurrent().code;
        this.generalMeetingsResource.getCurrent().subscribe(r => {
            this.currentMeeting = r.value;

            if (!this.currentMeeting) {
                this.exportFailed();
                return;
            }

            this.startExport();
        });
    }

    downloadExport(): void {
        Utils.saveFile(this.downloadFile, this.downloadFileName);
        this.dialogRef.close();
    }

    private startExport(): void {
        this.generalMeetingsResource.exportGeneralMeeting(Number(this.currentMeeting.id)).subscribe({
            next: this.exportSuccessful.bind(this),
            error: this.exportFailed.bind(this)
        });
    }

    private exportSuccessful(result: ApiResponseModel<string>): void {
        if (!result?.value) {
            return;
        }

        // convert base64 to byte array
        const binaryString = window.atob(result.value);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        // prepare download file
        const blob = new Blob([bytes]);
        const dateString = formatDate(new Date(), 'yyyy_MM_dd-HHmmss', this.currentLocaleCode);
        const fileName = `GmExport_${this.currentMeeting.id}_${dateString}.sharelogbackup`;
        this.downloadFileName = fileName;
        this.downloadFile = blob;

        this.isDone = true;
    }

    private exportFailed(): void {
        this.hasError = true;
        this.isDone = true;
    }
}
